const getters = {
    leaverequests: (state) => state.leaverequests,
    leaverequestId: (state) => state.leaverequestId,
    employee: (state) => state.employee,
    subordinate: (state) => state.subordinate,
    loading: state => state.loading
};

export default getters;